import { waitForElementToExist } from './waitForElement';
import { iconBasket } from '../components/iconCart';

/* eslint-disable */
export const addToCart = async () => {
	const initFuntion = async ({ c7Area }) => {
		// TODO: Activate this code when the product page is ready
		const button = c7Area.querySelector('button')
		const qty = c7Area.querySelector('input[name="quantity"]')
		const details = c7Area.querySelector('.c7-product__add-to-cart__price')
		const c7AreaStyleButton = c7Area.dataset.styleButton
		
		c7Area.querySelector('.c7-product__add-to-cart__form__quantity').style.maxWidth = 'none'
		c7Area.querySelector('.c7-product__add-to-cart__form__quantity').classList = c7Area.classList.contains('remove-qty') ? 'hidden' : 'relative flex flex-row bg-transparent border-[2px]  border-[var(--qty-border)]/60 rounded-3xl text-brown'

		details.classList.add('hidden')
		qty.classList = 'custom-input-qty'
		const qtyParent = qty.parentElement;
		qtyParent.classList = 'flex items-center w-20 h-full';
		/* qtyParent.insertAdjacentHTML('afterbegin', `<button type="button" data-action="decrement" class="w-10 border-r-[2px] border-opacity-60 border-[#C8CCBB] border-solid"><span class="m-auto text-2xl font-thin">−</span></button>`);
		qtyParent.insertAdjacentHTML('beforeend', `<button type="button" data-action="increment" class="w-10 border-l-[2px] border-opacity-60 border-[#C8CCBB] border-solid"><span class="m-auto text-2xl font-thin">+</span></button>`); */
		/* c7Area.querySelectorAll('button[data-action]').forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const action = button.dataset.action;
				const input = qty;
				const currentValue = parseInt(input.value);
				if (action === 'decrement') {
					const minValue = parseInt(input.min) || 1;
					let newValue = currentValue - 1;
					if (currentValue > minValue) {
						input.setAttribute('value', String(newValue));
						input.value = String(newValue);
					}
				} else if (action === 'increment') {
					const maxValue = parseInt(input.max) || 100;
					let newValue = currentValue + 1;
					if (currentValue < maxValue) {
						input.setAttribute('value', String(newValue));
						input.value = String(newValue);
					}
				}
			});
		}); */
		
		button.classList = `button font-base hover:text-white ${c7AreaStyleButton}`;
		c7AreaStyleButton === 'button-outline' && button.insertAdjacentHTML('beforeend', `${iconBasket({ props: 'class="mx-auto ml-1.5 mb-1 hover:stroke-white w-6 h-6 fill-brown hover:fill-white"', hideCounter: true, hideCircle: true, color: 'currentColor' })}`)
		
		// create an observer instance
		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					if (!button.classList.contains(`${c7AreaStyleButton}`)) {
						button.classList = `button font-base hover:text-white ${c7AreaStyleButton}`;
					}
				}
			}
		});

		// Configure the observer to observe attribute changes
		observer.observe(button, { attributes: true });
	}

	const c7ButtonArea = document.querySelectorAll('.c7-buy-product');
	if (c7ButtonArea) {
		c7ButtonArea.forEach((c7BuyButton) => {
			c7BuyButton.classList.add('hidden')
			waitForElementToExist({ selector: 'button', targetDocument: c7BuyButton }).then(() => {
				initFuntion({ c7Area: c7BuyButton }).then(() => {
					c7BuyButton.classList.remove('hidden')
				})
			})
		})
	}
}